package org.catharsis.spendtel.feature.data

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmField

@Serializable
data class SpendtelUser(
    val uid: String,
    val emailAddress: String,
    val joined: Long, // date joined
    val username: String,
    var profileImage: String? = null,
    @field:JvmField
    val isBlocked: Boolean = false,
    var fcmToken: String? = null,
    var generalNotificationsAllowed: Boolean = true,
    var groupMessageNotificationsAllowed: Boolean = true,
    val isAdmin: Boolean = false,
    val agreedToEULA: Boolean = false,
    var firstTimeOnPicksScreen: Boolean = true,
    var darkModeActive: Boolean = false,
    val financialGoal: String? = null,
    val financialGoalUpdatedAt: Long? = null,
)


fun SpendtelUser.toMap(): Map<String, Any> {
    return mapOf(
        "uid" to uid,
        "emailAddress" to emailAddress,
        "joined" to joined,
        "username" to username,
        "profileImage" to profileImage.orEmpty(),
        "isBlocked" to isBlocked,
        "fcmToken" to fcmToken.orEmpty(),
        "generalNotificationsAllowed" to generalNotificationsAllowed,
        "isAdmin" to isAdmin,
        "agreedToEULA" to agreedToEULA,
        "firstTimeOnPicksScreen" to firstTimeOnPicksScreen,
        "groupMessageNotificationsAllowed" to groupMessageNotificationsAllowed,
        "darkModeActive" to darkModeActive,
        "financialGoal" to financialGoal.orEmpty(),
        "financialGoalUpdatedAt" to (financialGoalUpdatedAt?.toDouble() ?: 0.0),
    )
}

fun SpendtelUser.toFirestoreMap(): Map<String, Any> {
    return mapOf(
        "uid" to uid,
        "emailAddress" to emailAddress,
        "joined" to joined.toDouble(),
        "username" to username,
        "profileImage" to profileImage.orEmpty(),
        "isBlocked" to isBlocked,
        "fcmToken" to fcmToken.orEmpty(),
        "generalNotificationsAllowed" to generalNotificationsAllowed,
        "isAdmin" to isAdmin,
        "agreedToEULA" to agreedToEULA,
        "firstTimeOnPicksScreen" to firstTimeOnPicksScreen,
        "groupMessageNotificationsAllowed" to groupMessageNotificationsAllowed,
        "darkModeActive" to darkModeActive,
        "financialGoal" to financialGoal.orEmpty(),
        "financialGoalUpdatedAt" to (financialGoalUpdatedAt?.toDouble() ?: 0.0),
    )
}

